import { TableViewStore, BaseListViewStore } from "core/stores";
import {
    ConfirmingReportItemService,
} from "application/confirming-report/services";
import { resolveColumns } from "application/facility/util/resolveColumns";

class ConfirmingReportPumpAndPoleItemListViewStore extends BaseListViewStore {
    constructor(rootStore) {

        const confirmingReportItemService = new ConfirmingReportItemService(
            rootStore.application.baasic.apiClient
        );

        const confirmingReportId = rootStore.routerStore.routerState.params.id;
        super(rootStore, {
            name: "confirming-report-pump-and-pole-item-list",
            routes: {},
            actions: () => {
                return {
                    find: async (params) => {
                        const response =
                            await confirmingReportItemService.getPumpAndPoleItems({
                                ...params,
                                confirmingReportId,
                                sort: "salesOrderNumber|asc",
                                fields: "id,salesOrderNumber,facility,patientFullName",
                            });
                        return response.data;
                    },
                };
            },
        });

        this.setTableStore(
            new TableViewStore(this.queryUtility, {
                columns: resolveColumns([
                    {
                        key: "salesOrderNumber",
                        title: "CONFIRMING_REPORT_ITEM.LIST.COLUMNS.SALES_ORDER_NUMBER",
                    },
                    {
                        key: "facility",
                        title: "CONFIRMING_REPORT_ITEM.LIST.COLUMNS.FACILITY",
                    },
                    {
                        key: "patientFullName",
                        title: "CONFIRMING_REPORT_ITEM.LIST.COLUMNS.PATIENT_FULL_NAME",
                    },
                ]),
            })
        );
    }
}

export default ConfirmingReportPumpAndPoleItemListViewStore;
